// 3rd Party
import React from 'react';

// Component
const VerifyPhoneSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    role="presentation"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#F37F6E" rx="20" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M25.385 11h-11.06A4.334 4.334 0 0010 15.324v4.191a4.334 4.334 0 004.324 4.325h4.396c.089.03.485.353.928.81 1.43 1.387 3.662 4.032 6.736 4.081a.764.764 0 00.646-1.17c-.946-1.498-1.143-2.563-1.145-3.224 0-.241.029-.414.06-.553 2.117-.28 3.763-2.076 3.765-4.269v-4.19A4.334 4.334 0 0025.384 11zm2.797 8.516a2.817 2.817 0 01-2.798 2.799.764.764 0 00-.65.361c-.06.094-.377.664-.377 1.662-.001.671.166 1.537.602 2.552-.994-.394-1.967-1.115-2.824-1.923-.632-.591-1.196-1.193-1.693-1.674a6.7 6.7 0 00-.723-.625c-.246-.164-.494-.338-.924-.352h-4.47a2.818 2.818 0 01-2.8-2.799l.002-4.191a2.818 2.818 0 012.798-2.799h11.06a2.818 2.818 0 012.799 2.799v4.19h-.002z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M24.944 14.94H14.767a.764.764 0 000 1.528h10.177a.764.764 0 000-1.527zm0 3.434H14.767a.764.764 0 000 1.527h10.177a.764.764 0 000-1.527z"
      />
    </g>
  </svg>
);
export default VerifyPhoneSvg;
